<script setup>
import HomeHeroSection from '@/pages/home/partials/HomeHeroSection.vue'
import HomeServicesSection from '@/pages/home/partials/HomeServicesSection.vue'
import HomeAboutSection from '@/pages/home/partials/HomeAboutSection.vue'
import HomeStatsSection from '@/pages/home/partials/HomeStatsSection.vue'
import HomeFeaturedProjectsSection from '@/pages/home/partials/HomeFeaturedProjectsSection.vue'
import HomeTestimonialsSection from '@/pages/home/partials/HomeTestimonialsSection.vue'
import ClickToActionSection from '@/components/ClickToActionSection.vue'

defineProps({
    featuredProjects: {
        type: Array,
        required: true,
    },
    testimonials: {
        type: Array,
        required: true,
    },
})
</script>

<template>
    <Head title="Vodoinstalace, topenářství a plynoinstalace">
        <meta
            name="description"
            content="Kalianko - rodinná firma s 30+ lety zkušeností. Vodoinstalace, topenářství a plynoinstalace v Olomouckém kraji. Profesionální servis a kvalitní materiály."
        />
    </Head>

    <HomeHeroSection />

    <HomeServicesSection class="section-width px-2 py-16 sm:py-24 lg:px-0 lg:py-32" />

    <HomeAboutSection class="py-16 sm:py-24 lg:py-32" />

    <HomeTestimonialsSection
        :testimonials="testimonials"
        class="section-width px-2 py-16 sm:py-24 lg:px-0 lg:py-32"
    />

    <HomeStatsSection />

    <HomeFeaturedProjectsSection
        :projects="featuredProjects"
        class="section-width px-2 py-16 sm:py-24 lg:px-0 lg:py-32"
    />

    <div class="section-width px-2 py-16 sm:py-24 lg:px-0 lg:py-32">
        <ClickToActionSection />
    </div>
</template>
